"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const art_layout_names_1 = __importDefault(require("./art-layout-names"));
const art_sets_backgrounds_1 = __importDefault(require("./art-sets-backgrounds"));
const tiles_1 = require("../tiles");
const fourLayouts = [
    {
        id: art_layout_names_1.default.QUARTET_PORTRAIT,
        displayName: 'Quartet',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3161120840630473,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4080560420315236,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5919439579684763,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.2530647985989492,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6366024518388792,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.12697022767075306,
                            y: 0.2600700525394046,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.3178633975481611,
                            y: 0.2600700525394046,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.2600700525394046,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6996497373029772,
                            y: 0.2600700525394046,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.QUARTET_LANDSCAPE,
        displayName: 'Quartet',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_11X8,
                        normalizedFrame: {
                            x: 0.2574430823117338,
                            y: 0.1777583187390543,
                            width: 0.15148861646234676,
                            height: 0.11471103327495621
                        }
                    },
                    {
                        id: 'scene_couch_wall_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_11X8,
                        normalizedFrame: {
                            x: 0.2574430823117338,
                            y: 0.30385288966725044,
                            width: 0.15148861646234676,
                            height: 0.11471103327495621
                        }
                    },
                    {
                        id: 'scene_couch_wall_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_11X8,
                        normalizedFrame: {
                            x: 0.4194395796847636,
                            y: 0.1777583187390543,
                            width: 0.15148861646234676,
                            height: 0.11471103327495621
                        }
                    },
                    {
                        id: 'scene_couch_wall_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_11X8,
                        normalizedFrame: {
                            x: 0.4194395796847636,
                            y: 0.30385288966725044,
                            width: 0.15148861646234676,
                            height: 0.11471103327495621
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_16X12,
                        normalizedFrame: {
                            x: 0.22329246935201402,
                            y: 0.0936952714535894,
                            width: 0.23555166374781086,
                            height: 0.1777583187390543
                        }
                    },
                    {
                        id: 'scene_couch_wall_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_16X12,
                        normalizedFrame: {
                            x: 0.22329246935201402,
                            y: 0.2863397548161113,
                            width: 0.23555166374781086,
                            height: 0.1777583187390543
                        }
                    },
                    {
                        id: 'scene_couch_wall_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_16X12,
                        normalizedFrame: {
                            x: 0.47373029772329245,
                            y: 0.0936952714535894,
                            width: 0.23555166374781086,
                            height: 0.1777583187390543
                        }
                    },
                    {
                        id: 'scene_couch_wall_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_16X12,
                        normalizedFrame: {
                            x: 0.47373029772329245,
                            y: 0.2863397548161113,
                            width: 0.23555166374781086,
                            height: 0.1777583187390543
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X20,
                        normalizedFrame: {
                            x: 0.09369527145359179,
                            y: 0.0148861646234676,
                            width: 0.3975481611208406,
                            height: 0.29422066549912435
                        }
                    },
                    {
                        id: 'scene_couch_wall_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X20,
                        normalizedFrame: {
                            x: 0.09369527145359179,
                            y: 0.31786339754816034,
                            width: 0.3975481611208406,
                            height: 0.29422066549912435
                        }
                    },
                    {
                        id: 'scene_couch_wall_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X20,
                        normalizedFrame: {
                            x: 0.5000000000000016,
                            y: 0.0148861646234676,
                            width: 0.3975481611208406,
                            height: 0.29422066549912435
                        }
                    },
                    {
                        id: 'scene_couch_wall_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X20,
                        normalizedFrame: {
                            x: 0.5000000000000016,
                            y: 0.31786339754816034,
                            width: 0.3975481611208406,
                            height: 0.29422066549912435
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.QUARTET_SQUARE,
        displayName: 'Quartet',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door3_4_1',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.680385288966725,
                            y: 0.38266199649737304,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    },
                    {
                        id: 'door3_4_2',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.680385288966725,
                            y: 0.2679509632224168,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    },
                    {
                        id: 'door3_4_3',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5656742556917689,
                            y: 0.38266199649737304,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    },
                    {
                        id: 'door3_4_4',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5656742556917689,
                            y: 0.2679509632224168,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'square_12x12_4_1',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.6751313485113836,
                            y: 0.38266199649737304,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    },
                    {
                        id: 'square_12x12_4_2',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.6751313485113836,
                            y: 0.22329246935201402,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    },
                    {
                        id: 'square_12x12_4_3',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.5157618213660246,
                            y: 0.38266199649737304,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    },
                    {
                        id: 'square_12x12_4_4',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.5157618213660246,
                            y: 0.22329246935201402,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door3_4_1',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.6760070052539404,
                            y: 0.3809106830122592,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    },
                    {
                        id: 'door3_4_2',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.6760070052539404,
                            y: 0.14010507880910683,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    },
                    {
                        id: 'door3_4_3',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.4316987740805604,
                            y: 0.3809106830122592,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    },
                    {
                        id: 'door3_4_4',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.4316987740805604,
                            y: 0.14010507880910683,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FOUR_TOWER,
        displayName: 'Tower',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain wall_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.17075306479859895,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain wall_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain wall_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain wall_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.5175131348511384,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain wall_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.12259194395796848,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain wall_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.28633975481611207,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain wall_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.4500875656742557,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain wall_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.6138353765323993,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain wall_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.2381786339754816,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain wall_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.4956217162872154,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain wall_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.10945709281961472,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain wall_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.36690017513134854,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FOUR_ORGANIC,
        displayName: 'Organic',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5586690017513135,
                            y: 0.34413309982486867,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6050788091068301,
                            y: 0.14010507880910683,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6733800350262698,
                            y: 0.34413309982486867,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7644483362521891,
                            y: 0.19964973730297722,
                            width: 0.09369527145359019,
                            height: 0.12259194395796848
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4868651488616462,
                            y: 0.37828371278458844,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5551663747810858,
                            y: 0.05604203152364273,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6462346760070052,
                            y: 0.37828371278458844,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.7994746059544658,
                            y: 0.17425569176882663,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FOUR_STAIRWAY,
        displayName: 'Stairway',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3161120840630473,
                            y: 0.27057793345008757,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4124343257443082,
                            y: 0.2180385288966725,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.16637478108581435,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6050788091068301,
                            y: 0.1138353765323993,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.23905429071803852,
                            y: 0.3169877408056042,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.37390542907180385,
                            y: 0.23905429071803852,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.16199649737302976,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6436077057793345,
                            y: 0.08493870402802102,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.10945709281961472,
                            y: 0.4028021015761821,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    },
                    {
                        id: 'stairway_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.30910683012259194,
                            y: 0.276707530647986,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    },
                    {
                        id: 'stairway_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.15061295971978983,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    },
                    {
                        id: 'stairway_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.7084063047285464,
                            y: 0.024518388791593695,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FOUR_VERTICAL,
        displayName: 'Vertical',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5805604203152365,
                            y: 0.2119089316987741,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5805604203152365,
                            y: 0.3563922942206655,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6952714535901926,
                            y: 0.17425569176882663,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6952714535901926,
                            y: 0.318739054290718,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5245183887915937,
                            y: 0.19176882661996497,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5245183887915937,
                            y: 0.3957968476357268,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6838879159369528,
                            y: 0.1330998248686515,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6838879159369528,
                            y: 0.3371278458844133,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FOUR_GRID,
        displayName: 'Grid',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5656742556917689,
                            y: 0.21541155866900175,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5656742556917689,
                            y: 0.35989492119089317,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.680385288966725,
                            y: 0.21541155866900175,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.680385288966725,
                            y: 0.35989492119089317,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5157618213660246,
                            y: 0.1532399299474606,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5157618213660246,
                            y: 0.3572679509632224,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6751313485113836,
                            y: 0.1532399299474606,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6751313485113836,
                            y: 0.3572679509632224,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4316987740805604,
                            y: 0.06042031523642732,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4316987740805604,
                            y: 0.38266199649737304,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6760070052539404,
                            y: 0.06042031523642732,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6760070052539404,
                            y: 0.38266199649737304,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FOUR_BLOCKS,
        displayName: 'Blocks',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'couch 228cm_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.33887915936952717,
                            y: 0.29859894921190894,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.45359019264448336,
                            y: 0.276707530647986,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.45359019264448336,
                            y: 0.4211908931698774,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5683012259194395,
                            y: 0.39929947460595444,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'couch 228cm_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.2723292469352014,
                            y: 0.22942206654991243,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4316987740805604,
                            y: 0.18126094570928197,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4308231173380035,
                            y: 0.38528896672504376,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5910683012259195,
                            y: 0.3371278458844133,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'couch 228cm_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.14448336252189142,
                            y: 0.12609457092819615,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'couch 228cm_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.38879159369527144,
                            y: 0.06042031523642732,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'couch 228cm_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.38879159369527144,
                            y: 0.38266199649737304,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'couch 228cm_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6330998248686515,
                            y: 0.3169877408056042,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FOUR_MOLECULAR,
        displayName: 'Molecular',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5175131348511384,
                            y: 0.3371278458844133,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5621716287215411,
                            y: 0.19264448336252188,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6768826619964974,
                            y: 0.22416812609457093,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6768826619964974,
                            y: 0.42819614711033277,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4299474605954466,
                            y: 0.30385288966725044,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5148861646234676,
                            y: 0.09982486865148861,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6742556917688266,
                            y: 0.1436077057793345,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6742556917688266,
                            y: 0.4658493870402802,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.FOUR_CLOUD,
        displayName: 'Cloud',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.BENCH_LAYOUTS,
                tiles: [
                    {
                        id: 'bench_4_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.27408056042031526,
                            y: 0.11821366024518389,
                            width: 0.16549912434325745,
                            height: 0.21891418563922943
                        }
                    },
                    {
                        id: 'bench_4_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3274956217162872,
                            y: 0.36339754816112085,
                            width: 0.11208406304728546,
                            height: 0.14798598949211908
                        }
                    },
                    {
                        id: 'bench_4_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4658493870402802,
                            y: 0.043782837127845885,
                            width: 0.11208406304728546,
                            height: 0.14798598949211908
                        }
                    },
                    {
                        id: 'bench_4_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4658493870402802,
                            y: 0.21891418563922943,
                            width: 0.2609457092819615,
                            height: 0.3607705779334501
                        }
                    }
                ]
            }
        ]
    }
];
exports.default = fourLayouts;
//# sourceMappingURL=four.js.map